import { useEffect } from "react";

import { PreloadedQuery } from "react-relay";

import FeatureGates from "@atlaskit/feature-gate-js-client";
import { ProductKeys } from "@atlassiansox/asc-stargate";

import { pricingPageRelayQuery } from "@/__generated_contentful__/pricingPageRelayQuery.graphql";
import { CrossFlowTouchpointProvider } from "@/components/cross-flow/touchpoint";
import { PricingContentContextProviderRelay } from "@/components/wpl/pricing/src/pricing-content-context.tsx";
import { IntercomProvider } from "@/libraries/intercom/src";
import { ConfluencePricingPageV2Template } from "@/templates/software/confluence/pricing/src";
import { experiments, useExperimentExposure } from "@/utils/experiment";
import { PricingContent } from "@/utils/pricing-queries/get-pricing-content.ts";

import { AppPricingData } from "../../../../contentful";
import { UserLocale } from "../../../../utils/useGeoCurrency";

export type ConfluencePricingPageProps = {
    pricing?: AppPricingData;
    countryCode?: UserLocale;
    pricingContent?: PricingContent;
    queryRef?: PreloadedQuery<pricingPageRelayQuery>;
};

export const ConfluencePricingPage = ({
    pricing,
    countryCode,
    pricingContent,
    queryRef
}: ConfluencePricingPageProps) => {
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom: boolean = FeatureGates.checkGate(
        "gwp-737-enable-intercom-chat-confluence"
    );

    const [
        pricingDirectBuyCheckoutFired,
        pricingDirectBuyCheckoutFireExposure
    ] = useExperimentExposure(experiments.pricingDirectBuyCheckout);
    useEffect(() => {
        if (!pricingDirectBuyCheckoutFired) {
            pricingDirectBuyCheckoutFireExposure();
        }
    }, [pricingDirectBuyCheckoutFired, pricingDirectBuyCheckoutFireExposure]);

    return (
        <IntercomProvider appId={"p0ww63i2"} triggerBoot={isBootIntercom}>
            <CrossFlowTouchpointProvider productKeys={[ProductKeys.CONFLUENCE]}>
                <PricingContentContextProviderRelay
                    productId="confluence"
                    pricingContent={pricingContent}
                    queryRef={queryRef}
                >
                    <ConfluencePricingPageV2Template
                        pricing={pricing}
                        countryCode={countryCode}
                    />
                </PricingContentContextProviderRelay>
            </CrossFlowTouchpointProvider>
        </IntercomProvider>
    );
};
